<div *ngIf="loadingspinner == true" class="spin"></div>

<fieldset [disabled]="loadingspinner == true" [ngClass]="{'disabled':loadingspinner == true}">


  <div class="d-flex flex-wrap" *ngIf="token">

    <div class="two-card common-padding add-money shadow">
      <button class="btn btn-primary" style="float: right;" (click)="Back()">Back</button>

      &nbsp;

      <h2 style="color:#356394;text-align:center;text-decoration:underline;">Cart Page</h2>

      <div class="row no-gutters">
        <div class="col-12 mt-4" *ngIf="responsearray.length==0">
          <span> No Product in Cart </span>
        </div>
        <div class="col-12 mt-4" *ngIf="responsearray.length!=0">

          <table class="table table-hover text-center table-bordered table-responsive" border="1">
            <thead class="theme-button text-white">
              <tr>
                <th scope="col">Course Name</th>
                <th scope="col">Quantity </th>
                <th scope="col">Course Price </th>
                <th scope="col">Action  </th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let x of responsearray">

                <td class="accept">
                  <span> {{x.Name}} </span>
                </td>
                <td class="accept">
                  <span> 1 </span>
                </td>

                <td class="accept">
                  <!--<span>  ₹ {{ ConToparseFloat(x.OtherDetails.Price) + ConToparseFloat(x.OtherDetails.GstAmount)}} </span>-->
                  <span>  ₹ {{ ConToparseFloat(x.OtherDetails.Price)}} </span>
                </td>
                <td class="accept">
                  <button type="button" class="btn btn-danger" (click)="removeProductToCart(x.ParentId)">Remove</button>&nbsp;
                </td>
              </tr>

            </tbody>
            <tfoot>

              <tr style="background-color:white">
                <th style="background-color:white">Total Price : </th>
                <td colspan="3">₹ {{totalprice}}</td>

              </tr>
              <!--
              <tr style="background-color:white">
                <th style="background-color:white">Choose Payment Option : </th>
                <td colspan="3">
                  <mat-radio-group aria-label="Select an option" aria-labelledby="example-radio-group-label" class="example-radio-group">
                    <mat-radio-button value="hdfc" (change)="changeMethod($event)" class="example-radio-button">
                      Option 1 - HDFC Bank

                    </mat-radio-button> &nbsp;

                    <mat-radio-button value="paybyvoucher" (change)="changeMethod($event)" class="example-radio-button">Option 2 - Pay By Promo Code</mat-radio-button>

                  </mat-radio-group>


                </td>

              </tr>
              -->
              <tr style="background-color:white" *ngIf="optionbtn == 'paybyvoucher'">
                <th style="background-color:white">Enter Valid Promo Code : </th>
                <td colspan="3">
                  <mat-form-field class="example-full-width">
                    <input matInput placeholder="Enter Promo Code" [(ngModel)]="VoucherCode" maxlength="200" required />

                    <mat-error *ngIf="submitted && VoucherCode==null" style="color: red;">
                      Promo Code is required
                    </mat-error>
                  </mat-form-field> 
                </td>

              </tr>
            </tfoot>
          </table>


          <p style="text-align:center;">
            <button class="primary-btn" type="button" style="width:20%; font-size:large; margin-top: 20px;background-color:#f44a4a;"
                    (click)="apiinarray();$event.preventDefault()">
              Checkout
            </button>
          </p>



        </div>
        <div class="col-12 mt-4">
          <div class="pay-detail text-center">
            <div class="icon_wrap">
              <i class="icon-payment_secure"></i>
            </div>
            <span class="ng-binding">Your payment details are secured</span>
          </div>
        </div>
      </div>
    </div>


  </div>


</fieldset>
